import { createAsyncThunk } from '@reduxjs/toolkit';
import { Context } from '@wix/wix-chatbot-common/browser';

import { IInitialChatData } from '../../../server/service/InitialChatData';
import { widgetSDK } from '../../sdk/widgetSDK';
import { chatbotStartChat } from '../api/chatbotStartChat';
import { TRootState } from '../reducers';

export type StartChatParams = Record<string, string>;

type StartChatArgs = {
  context: Context;
  editorType?: string;
};

export const loadChatbotStartChat = createAsyncThunk<IInitialChatData, StartChatArgs, { state: TRootState }>(
  'loadChatbotStartChat',
  async ({ context, editorType }, { getState }) => {
    const state = getState();
    const startChatParams = state.chat.startChatParameters || (await widgetSDK.getStartChatParams());
    const params = {
      ...startChatParams,
      ...(editorType ? { editorType } : {}),
    };
    return chatbotStartChat(params, context);
  },
);
